import {BasePath, BaseService, Body, GET, Path, POST, Query, Response} from 'ts-retrofit';
import {environment} from '../../../environments/environment';
import {GeoSurveyAteco, GeoSurveyAtecoDetail, GeoSurveyCompany, GeoSurveyCompanyResponse, GeoSurveySite, GeoSurveySiteAddress, QuestionsAnswareMap} from '../../data/riesko/responses/geo-survey/geo-survey-models';
import {GenericResponse} from '../../data/riesko/generic-response';

const base = 'survey';

@BasePath(environment.apiUrl + environment.basePrefixApiUrl)
export class GeoSurveyApiService extends BaseService {
  @GET(`/survey/{id}/lookup/ateco`)
  async getAtecoLookup(@Path('id') id: string): Promise<Response<GenericResponse<GeoSurveyAteco[]>>> {
    return {} as Response;
  }

  @GET(`/survey/{id}/lookup/ateco-detail/{code}`)
  async getAtecoDetail(@Path('id') id: string, @Path('code') code: string): Promise<Response<GenericResponse<GeoSurveyAtecoDetail[]>>> {
    return {} as Response;
  }

  @POST('/survey/{id}/compilation/init')
  async initCompilation(@Path('id') id: string, @Body data: GeoSurveyCompany): Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;
  }

  @POST('/survey/{id}/compilation/{surveyId}/step/setEconomics')
  async setEconomics(@Path('id') id: string,
                     @Path('surveyId') surveyId: string,
                     @Body data: { economics: { fatturato: number; export?: number; dipendenti?: number } },
                     @Query('hash') hash: string)
    : Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;
  }

  @POST('/survey/{id}/compilation/{surveyId}/step/callMe')
  async callMe(@Path('id') id: string,
                     @Path('surveyId') surveyId: string,
                     @Body data: { },
                     @Query('hash') hash: string)
    : Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;
  }

  @POST('/survey/{id}/compilation/{surveyId}/step/setResponse')
  async setResponses(@Path('id') id: string,
                     @Path('surveyId') surveyId: string,
                     @Body data: { responses: QuestionsAnswareMap },
                     @Query('hash') hash: string)
    : Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;

  }

  @POST('/survey/{id}/compilation/{surveyId}/step/addSite@{siteId}')
  async addSite(@Path('id') id: string,
                @Path('surveyId') surveyId: string,
                @Path('siteId') siteId: string,
                @Body data: { sites: [GeoSurveySiteAddress] },
                @Query('hash') hash: string)
    : Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;
  }

  @GET('/survey/{id}/lookup/comuni')
  async getCities(@Path('id') id: string): Promise<Response<GenericResponse<{ label: string, value: string }[]>>> {
    return {} as Response;
  }

  @POST('/survey/{id}/compilation/{surveyId}/step/setSite@{siteId}')
  async updateSite(@Path('id') id: string,
                   @Path('surveyId') surveyId: string,
                   @Path('siteId') siteId: string,
                   @Body data: { sites: [GeoSurveySiteAddress] },
                   @Query('hash') hash: string)
    : Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;
  }

  @POST('/survey/{id}/compilation/{surveyId}/step/submit')
  async completeSurvey(@Path('id') id: string,
                       @Path('surveyId') surveyId: string,
                       @Query('hash') hash: string
  ): Promise<Response<GenericResponse<GeoSurveyCompanyResponse>>> {
    return {} as Response;
  }
}
